import { Modal, useModalContext } from '../index'
import { Button } from '@highlight/ui'

export const DiscardChangesModal = () => {
  const { context, close } = useModalContext('discard-changes')

  function handleConfirm() {
    close()
    context.onConfirm()
  }

  return (
    <Modal confirm>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Discard unsaved changes?</Modal.Title>
          <Modal.Description>
            You have edits that haven&apos;t been saved. Leaving now will discard them.
          </Modal.Description>
        </Modal.Header>
        <Modal.Footer>
          <Modal.Close variant="secondary">Keep editing</Modal.Close>
          <Button variant="primary" tone="danger" onClick={handleConfirm}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
